module.exports = __webpack_public_path__ + "static/img/fla.29ef85e7.png";